import type { ReportRequest } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Input,
  Label,
  InfoButton,
  ValidationContainer,
  ValidationMessage,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEventHandler } from "react"
import { useCallback } from "react"
import styles from "./Reports.module.scss"
import { usePolyglot } from "src/contexts"

const id = "email-input-id"
const polyglotPrefix = "pages.settings.generate_report.email."

const emailInputErrorId = "email-input-error-id"

interface Props {
  reportRequest: ReportRequest;
  updateReportRequest: (reportRequest: Partial<ReportRequest>) => void;
}

export function EmailInput(props: Props) {
  const {
    updateReportRequest,
    reportRequest,
  } = props

  const polyglot = usePolyglot()

  const onChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      updateReportRequest({
        email: e.target.value,
      })
    },
    [updateReportRequest],
  )

  return (
    <div>
      <Label htmlFor={id}>
        {polyglot.t(`${polyglotPrefix}label`)}
        <InfoButton title={polyglot.t(`${polyglotPrefix}info_title`)}>
          {polyglot.t(`${polyglotPrefix}info_description`)}
        </InfoButton>
      </Label>
      <ValidationContainer className={styles.inputContainer}>
        <Input
          className={styles.emailInput}
          value={reportRequest.email}
          onChange={onChange}
          type="email"
          id={id}
          autoComplete="email"
          required
        />
        <ValidationMessage
          id={emailInputErrorId}
          stylePreset="absolute"
          invalidMessage={{
            valueMissing: polyglot.t("validation_message.value_missing"),
            typeMismatch: polyglot.t("validation_message.email_type_mismatch"),
          }}
        />
      </ValidationContainer>
    </div>
  )
}
